<template>
  <div class="content__area">
    <div class="container-fluid">
      <div class="content__wrapper">
        <div class="content__box">
          <!---- restricted --->
          <div class="content__box__header">
            <div
              class="
                d-flex
                align-items-center
                justify-content-between
                flex-wrap
              "
            >
              <div class="order-1">
                <p class="text-white txt--ss opacity--50 mb-1">Validations</p>
              </div>

               <div class="order-1 d-flex mb-1">
                <div class="ml-5">
                  <input
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    class="input__field"
                    style="width:150% !important"
                    v-model="search"
                    @keyup="searchData"
                  />
                </div>
              </div>
              <div class="order-1 d-flex mb-1 ml-5">
                <div class="ml-5 top__filter__ul">
                  <p class="text-white txt--ss opacity--50 mb-1">Status</p>
                </div>
                <div class="ml-2">
                 <v-select
                            class="style-chooser monthly-filter-select selectTransparent "
                            label="name"
                            :searchable="false"
                            v-model="selected_status"
                            transition="none"
                            :options="status_list"
                            :clearable="false"
                            :reduce="(name) => name.value"
                            @input="changeSelectedStatus()"
                            placeholder="Select Status"
                          >
                  </v-select>
                </div>
              </div>

              <div class="order-1 d-flex mb-1 ml-1" v-if="search!='' || selected_status!=-1">
                <div class="ml-5 top__filter__ul">
                  <p class="text-white txt--ss opacity--50 mb-1 cursor-pointer" @click="resetFilter">Clear Filters</p>
                </div>
              </div>

              <!-- PROPERTY DROPDOWN -->
              <div class="d-flex align-items-center order-3 ml-auto">
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openModal('managevalidation-reason-modal')"
                >
                  Manage Validation Reason
                </p>
                <p
                  class="txt--off-white txt--ss mb-1 cursor-pointer mr-3"
                  @click="openModal('managesend-validation-modal')"
                  v-if="invitation_access"
                >
                  Manage/Send Validations
                </p>
                <p
                  v-if="invitation_access"
                  class="txt--off-white txt--ss mb-1 cursor-pointer"
                  @click="openModal('create-validation-modal')"
                >
                  + Create Validation
                </p>
              </div>
            </div>
          </div>
          <div class="content__divider"></div>
          <div class="content__box__body content__box__body__audit__table">
            <div class="table-responsive">
              <input type="hidden" id="permitId" />
              <table class="table table__audit table-borderless">
                <thead>
                  <tr>
                    <th>Validation Name</th>
                    <th>Price</th>
                    <th>Single/Multi Property</th>
                    <th>Single/Multi Department</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-for="(validation, index) in validations" :key="index">
                  <tr style="cursor: default">
                    <td class="cursor-pointer" v-tooltip="'Edit Validation'">
                      {{validation.name}}
                    </td>
                    <td>
                      {{validation.price}}                    
                    </td>
                    <td>
                      <p 
                        title="click to copy" 
                        class="cursor-pointer" 
                        v-if="validation.all_properties == true"
                      >
                        {{'Multi'}}
                      </p>
                      <p 
                        title="click to copy" 
                        class="cursor-pointer"
                        v-else-if="validation.properties_list.length > 1"
                      >
                        {{'Multi'}}
                      </p>
                      <p 
                        title="click to copy" 
                        class="cursor-pointer"
                        v-else
                      >
                        {{'Single'}}
                      </p>
                    </td>
                    <td>
                      <p title="click to copy" class="cursor-pointer">
                        Single
                      </p>
                    </td>
                    <td>
                      
                       <span class="cursor-pointer"
                          :class="{
                          'txt--green': validation.status === 1 || validation.status === 'active',
                          'txt--red': validation.status === 0,
                          'txt--yellow': validation.status === 2,
                        }"
                        
                        @click="
                          changeValidationStatus(validation.id, validation.status)
                        "
                        >
                        {{
                          validation.status == 1
                            ?"Active"
                            :  (validation.status == 0)?'Inactive':'Pending'
                        }}
                        </span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center">
                        <span
                          class="cursor-pointer"
                          @click="editValidation(validation)"
                        >
                          Edit
                        </span>
                        <span
                          class="cursor-pointer txt--red ml-2"
                          @click="deleteValidation(validation.id)"
                        >
                          Delete
                        </span>
                      </div>
                       
                    </td>
                  </tr>
                </tbody>
              </table>

              <infinite-loading
                @infinite="getValidationList"
                :distance="10"
                force-use-infinite-wrapper=".content__box__body.content__box__body__audit__table"
                v-if="validations !== null && validations.length > 0 && validationPagination.load_more"
                :identifier="validation_infiniteId"
              >
                <div slot="spinner">
                  <div class="d-flex justify-content-center mt-4">
                    <div class="lds-ring">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
                <div slot="no-more"></div>
                <div slot="no-results">No data found</div>
              </infinite-loading>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreateValidation @update_validation_list="refresh"></CreateValidation>
    <EditValidation @update_validation_list="refresh"></EditValidation>
    <ManageSendValidationVue title="TitleName" childModalName="send-validation-modal"></ManageSendValidationVue>
    <SendValidation></SendValidation>
    <ManageValidationReason />
    <ManageValidationReasonEdit />
  </div>
</template>
<script>
import SendValidation           from "../../components/modals/SendValidation";
import commonservices           from "../../services/CommonService";
import CreateValidation         from "@/components/modals/CreateValidation";
import ManageSendValidationVue  from "../../components/modals/ManageSendValidation.vue";
import EditValidation           from "../../components/modals/editValidation.vue";
import ManageValidationReason from "../../components/modals/ManageValidationReason.vue";
import ManageValidationReasonEdit from "../../components/modals/ManageValidationReasonEdit.vue"

const service = new commonservices();
export default {
  name: "ValidationList",
  components: {
    CreateValidation,
    SendValidation,
    ManageSendValidationVue,
    EditValidation,
    ManageValidationReason,
    ManageValidationReasonEdit
},
  data() {
    return {
      validationPagination: {
        to:         0,
        page:       1,
        total:      0,
        load_more:  true,
        infiniteId: +new Date(),
      },
      user: {},
      user_role: "",
      validations: [],
      access_lists: null,
      property_id_list: [],
      invitation_access: true,
      validation_infiniteId: +new Date(),
      order_by:'DESC',
      field_name:'updated_at',
      search:'',
      selected_status:-1,
      status_list:[],
      pending_application_source: null,
    };
  },
  directives: {
    "click-outside": {
      bind: function (el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== "function") {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) {
            warn += `Found in component '${compName}'`;
          }

          // console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener("click", handler);
      },

      unbind: function (el, binding) {
        // Remove Event Listeners
        document.removeEventListener("click", el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
        // console.log(binding);
      },
    },
  },
  watch: {
  },
  created() {

    var objStatus = { "all": -1, "active": 1, "inactive": 0};
    this.status_list = [];

    for (const [key, value] of Object.entries(objStatus)) {
      console.log(key, value);
          this.status_list.push({
              name: key,
              value: value,
          });
    }
    this.getValidationList();
  },
  methods: {
    getValidationList()
    {

      if (this.pending_application_source) {
        this.pending_application_source.cancel("Cancel previous request");
      }
      const CancelToken = this.axios.CancelToken;
      this.pending_application_source = CancelToken.source();

      this.axios
        .post(window.hostname + "/api/auth/validation/getValidationList",
        {
            page: this.validationPagination.page,
            device_type:  1,
            search: this.search,
            status: this.selected_status,
            order_by:     this.order_by,
            field_name:   this.field_name,
        }, 
        {
          cancelToken: this.pending_application_source.token
        })
        .then((res) => {

          if (res.data.status && Object.keys(res.data.data.validation_list).length > 0 )
          {
            let validation_Lists = res.data.data.validation_list;
              validation_Lists.map((val) => {
              this.validations.push(val);
            });

            this.validationPagination.to        = res.data.data.pagination.to;
            this.validationPagination.page      = res.data.data.pagination.page;
            this.validationPagination.total     = res.data.data.pagination.total;
            this.validationPagination.load_more = res.data.data.pagination.load_more == 1 ? true : false;
            this.validation_infiniteId++;
          }
          else
          {
            this.validations = [];
            this.validationPagination.to = 0;
            this.validationPagination.page = 1;
            this.validationPagination.total = 0;
            this.validationPagination.load_more = false;
          }
        })
        .catch((err) => {

        });
    },
    openModal(modalName) {
      this.$modal.show(modalName);
    },
    refresh() {
      this.validationPagination.page = 1;
      this.validationPagination.load_more = false;
      this.validations = [];
      this.getValidationList();
    },
    resetFilter(){
      this.selected_status=-1;
      this.search = '';
      this.getValidationList();
    },
    searchData(){

      this.validation_infiniteId = +new Date();
      this.refresh();
      this.getValidationList();
    },
    changeSelectedStatus(){

      this.validation_infiniteId = +new Date();
      this.refresh();
      this.getValidationList();

    },
    editValidation(validation)
    {
      this.$modal.show('edit-validation-modal',{
        validation: JSON.parse(JSON.stringify(validation))
      });
    },
    deleteValidation(validation_id)
    {
       this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this Validation?",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/validation/new-delete", {
              validation_id: validation_id,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.refresh();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
            })
            .catch((err) => {
              this.$toasted.show(err.response.data.message, {
                icon: "times-circle",
                className: "error-class",
              });
            });
        }
      });

    },
    changeValidationStatus(validation_id,status){

        const statusChangeTo = status === 0 ? 1 : 0;
        const vm = this;
        let message = "Do you want to change the validation status?";
        const self = this;
        this.$swal({
          title: "Are you sure?",
          text: message,
          showCancelButton: true,
        }).then((result) => {
        if (result.value) {
          this.axios
            .post(window.hostname + "api/auth/validation/update-status", {
              validation_id: validation_id,
              status: statusChangeTo,
            })
            .then((res) => {
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                vm.refresh();
              }
              else{
                this.$toasted.show(res.data.message,{
                  icon : 'times-circle',
                  className: 'error-class'
                });   
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
  },
};
</script>

<style>
/* style the background and the text color of the input ... */
.vue-tags-input {
  border-radius: 16px !important;
  background: transparent !important;
  font-size: 12px !important;
  padding: 0 0.6rem !important;
  border: 1px solid hsla(0, 0%, 100%, 0.25) !important;
  max-width: 100% !important;
  -webkit-transition: all 0.2s ease-in-out;
  transition: all 0.2s ease-in-out;
  color: hsla(0, 0%, 100%, 0.5);
}

.vue-tags-input.ti-focus {
  border-color: #f5a621 !important;
}

.vue-tags-input .ti-new-tag-input {
  background: transparent !important;
  color: #b7c4c9;
}

.ti-input {
  border: 0 !important;
  padding: 4px 10px;
  transition: border-bottom 200ms ease;
}

/* we cange the border color if the user focuses the input */
.vue-tags-input.ti-focus .ti-input {
  border: 1px solid #ebde6e;
}

/* some stylings for the autocomplete layer */
.vue-tags-input .ti-autocomplete {
  background: #191919 !important;
  border: 0 !important;
  border-top: none !important;
  border-radius: 10px !important;
  width: 148px !important;
  top: 35px !important;
  padding-top: 10px !important;
}

/* the selected item in the autocomplete layer, should be highlighted */
.vue-tags-input .ti-item {
  color: #fff;
}

.vue-tags-input .ti-item.ti-selected-item {
  background-color: transparent;
}

/* style the placeholders color across all browser */
.vue-tags-input ::-webkit-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input ::-moz-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-ms-input-placeholder {
  color: #a4b1b6;
}

.vue-tags-input :-moz-placeholder {
  color: #a4b1b6;
}

/* default styles for all the tags */
.vue-tags-input .ti-tag {
  position: relative !important;
  background: transparent !important;
  color: #fff !important;
  align-items: center !important;
}

/* the styles if a tag is invalid */
.vue-tags-input .ti-tag.ti-invalid {
  background-color: #e88a74;
}

/* if the user input is invalid, the input color should be red */
.vue-tags-input .ti-new-tag-input.ti-invalid {
  color: #e88a74;
}

/* if a tag or the user input is a duplicate, it should be crossed out */
.vue-tags-input .ti-duplicate span,
.vue-tags-input .ti-new-tag-input.ti-duplicate {
  text-decoration: line-through;
}

/* if the user presses backspace, the complete tag should be crossed out, to mark it for deletion */
.vue-tags-input .ti-tag:after {
  transition: transform 0.2s;
  position: absolute;
  content: "";
  height: 2px;
  width: 108%;
  left: -4%;
  top: calc(50% - 1px);
  background-color: #000;
  transform: scaleX(0);
}

.vue-tags-input .ti-deletion-mark:after {
  transform: scaleX(1);
}

.ti-tag .ti-actions {
  background-color: rgba(255, 255, 255, 0.2) !important;
  font-size: 8px !important;
  justify-content: center !important;
  width: 13px !important;
  height: 13px !important;
  border-radius: 100% !important;
  color: rgba(255, 255, 255, 0.25) !important;
}

.date-range-time-class-audit .date__range__input .field.is-dark .field-input {
  width: 150px;
  padding: 0 10px;
}

.date-range-time-class-audit .time-picker::after,
.date-range-time-class-audit .time-picker::before {
  border-top: 0;
  border-bottom: 0;
}

@media (max-width: 460px) {
  .date-range-time-class-audit {
    flex-direction: column;
  }

  .date-range-time-class-audit .separator {
    display: none;
  }

  .date-range-time-class-audit .date__range__input {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
}
</style>